const API_URL = process.env.REACT_APP_API_URL || 'https://api.tcf-studio.dev';

const getHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

export const searchUsers = async (query) => {
  const response = await fetch(`${API_URL}/users/search?q=${encodeURIComponent(query)}`, {
    method: 'GET',
    headers: getHeaders()
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Failed to search users');
  return data;
};

export const listUsers = async () => {
  const response = await fetch(`${API_URL}/users`, {
    method: 'GET',
    headers: getHeaders()
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Failed to load users');
  return data;
};

export const updateUserRole = async (userId, role) => {
  const response = await fetch(`${API_URL}/users/${userId}/role`, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify({ role })
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Failed to update role');
  return data;
};

/**
 * Permanently remove an account.
 *
 * The Worker answers 409 when the account still owns something that would
 * outlive it (a cluster that is not torn down, a curated image, billing
 * history). That is a normal outcome, not a bug, so the message is surfaced
 * verbatim -- it names what is in the way.
 */
export const deleteUser = async (userId) => {
  const response = await fetch(`${API_URL}/users/${userId}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Failed to delete user');
  return data;
};

export default { searchUsers, listUsers, updateUserRole, deleteUser };
